import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7d51290"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Dashboard grid padded footer-white-after" }
const _hoisted_2 = {
  class: "Dashboard-left",
  id: "dashboardContainer"
}
const _hoisted_3 = { class: "Dashboard--intro_title h1" }
const _hoisted_4 = { class: "small-uppercase" }
const _hoisted_5 = { class: "small-uppercase" }
const _hoisted_6 = { class: "small-uppercase color--3" }
const _hoisted_7 = { class: "h2 color--2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 88 56",
  class: "color--2"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-list-item" })
], -1))
const _hoisted_9 = { class: "Dashboard-Card-img round" }
const _hoisted_10 = { class: "small-uppercase" }
const _hoisted_11 = { class: "small-uppercase color--3" }
const _hoisted_12 = { class: "h2 color--2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 88 56",
  class: "color--2"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-list-item" })
], -1))
const _hoisted_14 = { class: "Dashboard-Card-img round" }
const _hoisted_15 = { class: "small-uppercase" }
const _hoisted_16 = { class: "small-uppercase color--3" }
const _hoisted_17 = { class: "h2 color--2" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" / 15 ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 88 56",
  class: "color--2"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-list-item" })
], -1))
const _hoisted_20 = { class: "Dashboard-Card-img big" }
const _hoisted_21 = { class: "bottles" }
const _hoisted_22 = ["srcset"]
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { class: "Dashboard--section_title" }
const _hoisted_25 = { class: "small-uppercase" }
const _hoisted_26 = { class: "small-uppercase" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spacer",
  style: {"height":"20vh"}
}, null, -1))
const _hoisted_28 = {
  class: "Dashboard-right",
  "data-sticky-container": "",
  "data-scroll-section": ""
}
const _hoisted_29 = { class: "Dashboard--section_title" }
const _hoisted_30 = { class: "small-uppercase color--3" }
const _hoisted_31 = { class: "Dashboard--section_background" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Dashboard--section_background-inner" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", null, [
  /*#__PURE__*/_createElementVNode("source", { srcset: "/images/dashboard/courses-completion.png 1x, /images/dashboard/courses-completion@2x.png 2x" }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/dashboard/courses-completion.png",
    alt: "courses completion image"
  })
], -1))
const _hoisted_34 = { class: "Dashboard--section_content" }
const _hoisted_35 = { class: "h3" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_37 = { class: "Dashboard--section_title" }
const _hoisted_38 = { class: "small-uppercase color--3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Dashboard--section_background" }, [
  /*#__PURE__*/_createElementVNode("picture", null, [
    /*#__PURE__*/_createElementVNode("source", { srcset: "/images/dashboard/program-started.png 1x, /images/dashboard/program-started@2x.png 2x" }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/images/dashboard/program-started.png",
      alt: "program started image"
    })
  ])
], -1))
const _hoisted_40 = { class: "Dashboard--section_content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_DashboardCertificate = _resolveComponent("DashboardCertificate")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LazyPicture = _resolveComponent("LazyPicture")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!
  const _component_DashboardMyEvents = _resolveComponent("DashboardMyEvents")!
  const _component_DashboardEvents = _resolveComponent("DashboardEvents")!
  const _component_DashboardJobs = _resolveComponent("DashboardJobs")!
  const _component_DashboardCompletionProgress = _resolveComponent("DashboardCompletionProgress")!
  const _component_StickyElement = _resolveComponent("StickyElement")!
  const _component_MobileShortcuts = _resolveComponent("MobileShortcuts")!
  const _component_LayoutConnected = _resolveComponent("LayoutConnected")!

  return (_openBlock(), _createBlock(_component_LayoutConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_AppearObject, {
            class: "Dashboard--intro",
            "data-scroll-section": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", _hoisted_3, [
                _createElementVNode("span", null, [
                  _createVNode(_component_LineByLine, {
                    innerHTML: _ctx.alreadyCame ? _ctx.$t('dashboard.welcome_back') : _ctx.$t('dashboard.welcome')
                  }, null, 8, ["innerHTML"])
                ]),
                _createVNode(_component_LineByLine, {
                  innerHTML: _ctx.user.firstName
                }, null, 8, ["innerHTML"])
              ])
            ]),
            _: 1
          }),
          (_ctx.hasOneCertificate)
            ? (_openBlock(), _createBlock(_component_AppearObject, {
                key: 0,
                class: "Dashboard--section",
                "data-scroll-section": ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('dashboard.certificate')), 1),
                  _createVNode(_component_DashboardCertificate, {
                    certificates: _ctx.certificates,
                    oldCertificates: _ctx.oldCertificates
                  }, null, 8, ["certificates", "oldCertificates"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.hasAllCertificates && _ctx.currentCourse)
            ? (_openBlock(), _createBlock(_component_AppearObject, {
                key: 1,
                class: "Dashboard--section",
                "data-scroll-section": ""
              }, {
                default: _withCtx(() => [
                  (_ctx.currentCourse && _ctx.currentCourse.type === 'course' && _ctx.currentChapter)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('dashboard.continue')), 1),
                        _createVNode(_component_DashboardCard, { course: _ctx.currentCourse }, {
                          header: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.courseTitle), 1)
                          ]),
                          title: _withCtx(() => [
                            _createElementVNode("h2", _hoisted_7, [
                              _createVNode(_component_LineByLine, {
                                innerHTML: _ctx.currentChapter?.title,
                                debug: true
                              }, null, 8, ["innerHTML"])
                            ])
                          ]),
                          cta: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: `/chapter/${_ctx.currentChapter.slug}`
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('dashboard.start_chapter')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          image: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              (_ctx.courseImage?.url)
                                ? (_openBlock(), _createBlock(_component_LazyPicture, {
                                    key: 0,
                                    image: _ctx.courseImage,
                                    alt: _ctx.courseTitle,
                                    class: "picture--appear"
                                  }, null, 8, ["image", "alt"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }, 8, ["course"])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.currentCourse && _ctx.currentCourse.type === 'test')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('dashboard.continue')), 1),
                        _createVNode(_component_DashboardCard, { course: _ctx.currentCourse }, {
                          header: _withCtx(() => [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.currentCourse?.categoryName), 1)
                          ]),
                          title: _withCtx(() => [
                            _createElementVNode("h2", _hoisted_12, [
                              _createVNode(_component_LineByLine, { innerHTML: _ctx.courseTitle }, null, 8, ["innerHTML"])
                            ])
                          ]),
                          cta: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: `/test/${_ctx.currentCourse.slug}`
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('dashboard.start_test')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          image: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, [
                              (_ctx.courseImage?.url)
                                ? (_openBlock(), _createBlock(_component_LazyPicture, {
                                    key: 0,
                                    image: _ctx.courseImage,
                                    alt: _ctx.courseTitle,
                                    class: "picture--appear"
                                  }, null, 8, ["image", "alt"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }, 8, ["course"])
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_AppearObject, {
            class: "Dashboard--section",
            "data-scroll-section": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_15, [
                _createVNode(_component_LineByLine, {
                  innerHTML: _ctx.$t('dashboard.back_bar')
                }, null, 8, ["innerHTML"])
              ]),
              _createVNode(_component_DashboardCard, { theme: 'back-bar' }, {
                header: _withCtx(() => [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('dashboard.achievements')), 1)
                ]),
                title: _withCtx(() => [
                  _createElementVNode("h2", _hoisted_17, [
                    _createElementVNode("span", null, [
                      _createVNode(_component_LineByLine, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.achievements?.length || 0), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_18
                  ])
                ]),
                cta: _withCtx(() => [
                  _createVNode(_component_router_link, { to: `/my-profile/rewards` }, {
                    default: _withCtx(() => [
                      _hoisted_19,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('dashboard.explore')), 1)
                    ]),
                    _: 1
                  })
                ]),
                image: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.achievements.slice(0, _ctx.achievements.length < 3 ? _ctx.achievements.length : 3), (achievement, i) => {
                        return (_openBlock(), _createElementBlock("picture", {
                          key: `bottle-${ achievement.bottle }`,
                          class: _normalizeClass(`bottle bottle-${ i+1 }`)
                        }, [
                          _createElementVNode("source", {
                            srcset: `/images/backbar/bottles/bottle${achievement.bottle}.png 1x, /images/backbar/bottles/bottle${achievement.bottle}@2x.png 2x`
                          }, null, 8, _hoisted_22),
                          _createElementVNode("img", {
                            src: `/images/backbar/bottles/bottle${achievement.bottle}.png`,
                            alt: _ctx.$t('backbar.bottleTitle' + achievement.bottle)
                          }, null, 8, _hoisted_23)
                        ], 2))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_AppearObject, {
            class: "Dashboard--section my-events",
            "data-scroll-section": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DashboardMyEvents)
            ]),
            _: 1
          }),
          _createVNode(_component_AppearObject, {
            class: "Dashboard--section events",
            "data-scroll-section": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", _hoisted_25, [
                  _createVNode(_component_LineByLine, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('dashboard.events_title')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_component_DashboardEvents)
            ]),
            _: 1
          }),
          _createVNode(_component_AppearObject, {
            class: "Dashboard--section",
            "data-scroll-section": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_26, [
                _createVNode(_component_LineByLine, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('dashboard.jobs_available')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_DashboardJobs)
            ]),
            _: 1
          }),
          _hoisted_27
        ]),
        _createElementVNode("aside", _hoisted_28, [
          _createVNode(_component_StickyElement, {
            gapTop: _ctx.gapTop,
            gapBottom: _ctx.gapBottom
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppearObject, {
                class: "Dashboard--section courses-completion",
                onAppear: _cache[0] || (_cache[0] = () => { this.$refs.completionProgress.start() })
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('dashboard.courses_title')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_DashboardCompletionProgress, {
                      progress: _ctx.user.progress,
                      ref: "completionProgress"
                    }, null, 8, ["progress"]),
                    _hoisted_33
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("h3", _hoisted_35, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_LineByLine, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.user.progress), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_36
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('dashboard.courses_description')), 1)
                  ])
                ]),
                _: 1
              }),
              (_ctx.hasStarted)
                ? (_openBlock(), _createBlock(_component_AppearObject, {
                    key: 0,
                    class: "Dashboard--section program-started"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('dashboard.program_started')), 1)
                      ]),
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("h3", {
                          class: _normalizeClass(["text-lg", { 'too-long': _ctx.daysAgo > 999 }])
                        }, [
                          _createElementVNode("span", null, [
                            _createVNode(_component_LineByLine, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.daysAgo > 999 ? _ctx.$t('dashboard.long') : _ctx.daysAgo), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.daysAgo > 999 ? _ctx.$t('dashboard.time_ago') : _ctx.$t('dashboard.days_ago')), 1)
                        ], 2)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["gapTop", "gapBottom"])
        ]),
        _createVNode(_component_MobileShortcuts)
      ])
    ]),
    _: 1
  }))
}